module.exports = __webpack_public_path__ + "static/media/JavaScript frameworks-amico-yellow.a43e7843.svg";